(function () {
var $66b821ea461d9f2a$exports = {};
"use strict";
const $66b821ea461d9f2a$var$currentPage = window.location.pathname;
const $66b821ea461d9f2a$var$navLinks = document.querySelectorAll(".nav-link, .btn-contact");
const $66b821ea461d9f2a$var$logoLink = document.querySelector(".logo-link");
const $66b821ea461d9f2a$var$btnBackToTop = document.querySelector(".btn-back-to-top");
// Button back to top
window.addEventListener("scroll", ()=>{
    if (window.scrollY > 300) $66b821ea461d9f2a$var$btnBackToTop.classList.add("active");
    else $66b821ea461d9f2a$var$btnBackToTop.classList.remove("active");
});
$66b821ea461d9f2a$var$btnBackToTop.addEventListener("click", ()=>{
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
});
[
    ...$66b821ea461d9f2a$var$navLinks
].forEach((navLink)=>navLink.addEventListener("click", function() {
        const sectionTopPosition = document.getElementById(this.dataset.section).getBoundingClientRect().top;
        window.scrollTo({
            top: sectionTopPosition + window.scrollY,
            behavior: "smooth"
        });
    }));
// Prevent refresh page on click if already on homepage
if ($66b821ea461d9f2a$var$currentPage === "/") {
    $66b821ea461d9f2a$var$logoLink.addEventListener("click", (e)=>{
        e.preventDefault();
    });
    $66b821ea461d9f2a$var$logoLink.style.pointerEvents = "none";
}

})();
//# sourceMappingURL=index.391f1d98.js.map
